<div class="tab-loading-area" *ngIf="friendsLoading">
  <div class="spinner-lg"></div>
  <span>Loading friends…</span>
</div>
<div class="error-msg" *ngIf="friendsError && !friendsLoading">{{ friendsError }}</div>

<div class="friends-search-row" *ngIf="!friendsLoading && !friendsError && friendThreads.length > 0">
  <input class="friends-search-input" type="text"
         [(ngModel)]="friendSearchTerm"
         placeholder="Search friends by name…"
         autocomplete="off" />
  <button class="friends-search-clear" type="button" *ngIf="friendSearchTerm"
          (click)="friendSearchTerm = ''" title="Clear search">✕</button>
</div>

<div class="inbox-empty" *ngIf="!friendsLoading && !friendsError && friendThreads.length === 0">
  No friends found.
</div>

<div class="inbox-empty" *ngIf="!friendsLoading && !friendsError && friendThreads.length > 0 && filteredFriendThreads.length === 0">
  No friends match "{{ friendSearchTerm }}".
</div>

<div class="inbox-list" *ngIf="!friendsLoading && filteredFriendThreads.length > 0">
  <div class="inbox-msg" [class.inbox-msg-open]="selectedFriendId === thread.friend.userId"
       *ngFor="let thread of filteredFriendThreads">

    <!-- Clickable header: expands/collapses the thread -->
    <div class="inbox-msg-header inbox-msg-header-btn"
         (click)="selectFriendThread(thread)">
      <span class="inbox-from">{{ thread.friend.name }}</span>
      <span class="unread-badge" *ngIf="thread.friend.unreadMessages > 0">{{ thread.friend.unreadMessages }}</span>
      <span class="inbox-meta">🏆 {{ thread.friend.trophies }}</span>
      <span class="inbox-meta inbox-pending" *ngIf="thread.isPending">Pending</span>
      <span class="inbox-date" *ngIf="thread.latestMessage">{{ thread.latestMessage.sentDate | date:'MMM d, HH:mm' }}</span>
      <span class="inbox-chevron">{{ selectedFriendId === thread.friend.userId ? '▲' : '▼' }}</span>
    </div>

    <!-- Preview (collapsed) -->
    <ng-container *ngIf="selectedFriendId !== thread.friend.userId">
      <div class="inbox-msg-body" *ngIf="thread.latestMessage">{{ thread.latestMessage.message }}</div>
      <div class="inbox-msg-body inbox-no-msg" *ngIf="!thread.latestMessage">No messages yet.</div>
    </ng-container>

    <!-- Expanded chat log -->
    <ng-container *ngIf="selectedFriendId === thread.friend.userId">
      <div class="chat-log">
        <div class="chat-no-msg" *ngIf="thread.messages.length === 0">No messages yet.</div>
        <div class="chat-msg" [class.chat-msg-mine]="msg.sentByMe" [class.chat-msg-theirs]="!msg.sentByMe"
             *ngFor="let msg of thread.messages">
          <div class="chat-msg-meta">
            <span class="chat-msg-from">{{ msg.sentByMe ? (session?.name || 'You') : thread.friend.name }}</span>
            <span class="chat-msg-date">{{ msg.sentDate | date:'MMM d, HH:mm' }}</span>
          </div>
          <div class="chat-msg-body">{{ msg.message }}</div>
        </div>
      </div>
      <!-- Reply form -->
      <div class="inbox-reply-form" (click)="$event.stopPropagation()">
        <textarea class="inbox-reply-input" [(ngModel)]="friendReplyText" rows="2"
                  placeholder="Reply to {{ thread.friend.name }}…"
                  [disabled]="friendReplySending || restrictedMode"></textarea>
        <div class="inbox-reply-actions">
          <button class="btn btn-primary btn-sm" (click)="sendFriendReply()"
                  [disabled]="!friendReplyText.trim() || friendReplySending || restrictedMode"
                  [title]="restrictedMode ? 'Messaging is disabled in restricted mode' : ''">
            {{ friendReplySending ? 'Sending…' : 'Send' }}
          </button>
        </div>
      </div>
    </ng-container>

  </div>
</div>

<div style="margin-top:0.5rem">
  <button class="btn btn-ghost btn-sm" (click)="loadFriends()" [disabled]="friendsLoading">↻ Refresh</button>
</div>

<div class="friends-debug" *ngIf="friendsDebug">{{ friendsDebug }}</div>
